import { render } from "./Link.vue?vue&type=template&id=69df1ea6&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import "./Link.vue?vue&type=style&index=0&id=69df1ea6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69df1ea6"]])

export default __exports__